import { Injectable } from "@angular/core";
import { filterNilValue, Query } from "@datorama/akita";
import { Observable } from "rxjs";
import type { GetOrganisationUnitsResponse } from "../../../api/nerri/organisations/types/get-organisation-units-response.type";
import { Properties } from "../../../api/nerri/properties/models/properties.model";
import { DashboardState, DashboardStore } from "./dashboard.store";

@Injectable()
export class DashboardQuery extends Query<DashboardState> {
    public roles$ = this.select("roles");
    public modules$ = this.select("modules").pipe(filterNilValue());

    constructor(store: DashboardStore) {
        super(store);
    }

    public selectHasCompletedIntroduction(): Observable<boolean> {
        return this.select("hasCompletedIntroduction");
    }

    public selectProperties(): Observable<Properties[]> {
        return this.select("properties");
    }

    public shouldShowNewSteps(): Observable<boolean> {
        return this.select(state => state.hasCompletedIntroduction && !state.hasSeenNewSteps);
    }

    public shouldShowIntroduction(): Observable<boolean> {
        return this.select(state => !state.hasCompletedIntroduction);
    }

    public selectUnits(): Observable<GetOrganisationUnitsResponse> {
        return this.select("units");
    }
}
